module.exports = __webpack_public_path__ + "static/img/12.dc406ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/12.jpg
// module id = z0dV
// module chunks = 16